import TitleBlock from '@anm/components/TitleBlock';
import getFromCdn from '@anm/helpers/getFromCdn';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

import { EmbedSizeType } from '../../../../../store/modules/hostedVideo';
import { subTitleStyles } from '../../Wrapper';
import { PlayerContainer } from '../PlayerBlock';

type CommonEmbedPreviewProps = {
  sizeType: EmbedSizeType;
  width?: number;
};

const commonEmbedPreviewOnMobiles = media.tablet`
  margin: 24px auto 20px;
`;

export const CommonPreviewWrapper = styled.div<CommonEmbedPreviewProps>`
  margin: 50px ${({ sizeType }) => (sizeType === 'fixed' ? '40px' : 0)} 31.5px;

  img {
    width: 100%;
  }

  ${commonEmbedPreviewOnMobiles};

  ${PlayerContainer} {
    margin: 0;
  }

  iframe {
    display: block;
    width: 100%;
    height: ${({ width = 520 }) => `${width / (16 / 9)}px`}; // TODO: handle vertical sizes when available
    border: none;
  }
`;

const previewWrapperOnMobiles = media.tablet`
  padding: 30px 0;
  margin-bottom: 22px;
  background: #F5F7FA;
`;

export const PreviewWrapper = styled.div`
  ${previewWrapperOnMobiles}
`;

export const PreviewTitle = styled(TitleBlock)`
  margin-bottom: 7px;
  ${subTitleStyles};
`;

export const ThumbnailPreviewWrapper = styled.div<{ height: number }>`
  width: 100%;
  cursor: pointer;
  height: ${({ height }) => `${height}px`};
  background: url(${getFromCdn('images/dashboard/default_preview.svg')}) no-repeat center/20% #ebeef5;
`;
